import React from "react";
import { Table } from "antd";

const PrintableReport = React.forwardRef(({ results, columns, reportName, printHeader }, ref) => {
    // If there are no results, we still render the outer div so the ref can be attached,
    // but the div will be empty and won't be printed.
    if (!results || results.length === 0) {
        return <div ref={ref}></div>;
    }

    return (
        <div ref={ref} style={{ padding: "20px", background: "white" }}>
            {printHeader && <pre style={{ textAlign: "center", fontSize: "16px", fontWeight: "bold" }}>{printHeader}</pre>}
            <h2 style={{ textAlign: "center", fontSize: "18px", marginBottom: "20px" }}>{reportName}</h2>
            <Table
                dataSource={results}
                columns={columns}
                pagination={false}
                rowKey={(record, index) => `print-${index}`}
                size="small"
                bordered
            />
        </div>
    );
});

export default PrintableReport;